var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applicationList"},[_c('Navbar',{attrs:{"title":"借款用途"}}),_c('div',{staticClass:"content"},[_vm._l((_vm.applicationList),function(item){return _c('div',{key:item.id},[_c('applicationListField',{attrs:{"itemData":item}})],1)}),_c('div',{staticClass:"footer-wrap"},[_vm._v(" 确定 ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }